// FAQs page: accordion behavior. Only one question is open at a time
// (matching the Figma default state, where "What is Masdr Company?" is
// open and the rest are collapsed). Clicking an open question closes it;
// clicking a closed question opens it and closes whichever was open.
// (function () {
//   const items = Array.prototype.slice.call(
//     document.querySelectorAll(".faq-item"),
//   );
//   if (!items.length) return;

//   function closeItem(item) {
//     const trigger = item.querySelector(".faq-item__trigger");
//     const panel = item.querySelector(".faq-item__panel");
//     item.classList.remove("is-open");
//     trigger.setAttribute("aria-expanded", "false");
//     panel.hidden = true;
//   }

//   function openItem(item) {
//     const trigger = item.querySelector(".faq-item__trigger");
//     const panel = item.querySelector(".faq-item__panel");
//     item.classList.add("is-open");
//     trigger.setAttribute("aria-expanded", "true");
//     panel.hidden = false;
//   }

//   items.forEach(function (item) {
//     const trigger = item.querySelector(".faq-item__trigger");

//     trigger.addEventListener("click", function () {
//       const isOpen = item.classList.contains("is-open");

//       items.forEach(function (other) {
//         if (other !== item) closeItem(other);
//       });

//       if (isOpen) {
//         closeItem(item);
//       } else {
//         openItem(item);
//       }
//     });
//   });
// })();

const faqItem = document.querySelectorAll(".faq-list .faq-item");
const faqTriggerBtn = document.querySelectorAll(".faq-item .faq-item__trigger");

faqTriggerBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    const clickedItem = btn.closest(".faq-item");

    faqItem.forEach((item) => {
      if (item === clickedItem) {
        item.classList.toggle("active");
      } else {
        item.classList.remove("active");
      }
    });
  });
});
